import styled from "styled-components";
import Close from "./icon/close.png";
import CloseHover from "./icon/close-hover.png";
export const PosterModalWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
export const PosterModalMask = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;
export const PosterModalContent = styled.div`
  position: absolute;
  z-index: 11;
`;

export const PosterModalClose = styled.div`
  width: 22px;
  height: 22px;
  position: absolute;
  cursor: pointer;
  right: -30px;
  top: 0;
  background: url(${Close}) no-repeat;
  background-size: contain;
  :hover {
    background-image: url(${CloseHover});
  }
`;

export const PosterModalTitle = styled.div`
  position: relative;
  width: 100%;
`;

export const PosterModalBody = styled.div`
  position: relative;
  .poster-content {
    .poster-bg {
      width: 414px;
    }
    .poster-info {
      position: absolute;
      top: 138px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      width: 100%;
      color: #000000;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      img {
        width: 27px;
        height: 27px;
      }
    }
  }
  button {
    width: 144px;
    height: 39px;
    margin: 13px auto 0;
    font-size: 16px;
  }
`;

export const QrCodeWrapper = styled.div`
  position: absolute;
  width: 160px;
  top: 260px;
  left: 0;
  right: 0;
  margin: auto;
`;
